import { render, staticRenderFns } from "./DisplayAccess.vue?vue&type=template&id=40039042&"
import script from "./DisplayAccess.vue?vue&type=script&lang=js&"
export * from "./DisplayAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports